import style from './LuckyCardsListing.css';

import { _className } from '../../../utils/classname.utils';
import { renderIf } from '../../../utils/render.utils';
import { useState } from 'preact/hooks';
import LuckyCardListItem from '../LuckyCardListItem/LuckyCardListItem';
import Button from '../../shared/Button/Button';
import useTranslation from '../../../localization/i18n.context';
import { DeeplinkEvent } from '../../../sdk/deeplink.event';
import NavigationUtils from '../../../utils/navigation.utils';
import { TrackingEvent } from '../../../sdk/tracking.event';
import useConfig from '../../../config/config.context';
import CaasStorageKeys from '../../../constants/caas.storage.keys';

const DEFAULT_SHOWING_CARD_NUMBER = 3;

export default function LuckyCardsListing({
  cards = [],
  lendingButtonEnabled = false,
}) {
  const { t } = useTranslation();
  const { config, updateStorage } = useConfig();
  const defaultCards = cards.slice(0, DEFAULT_SHOWING_CARD_NUMBER);
  const hiddenCards = cards.slice(DEFAULT_SHOWING_CARD_NUMBER);

  function onCardItemClick(card) {
    TrackingEvent.trigger(
      TrackingEvent.Events.DISCOVER_TAP_ACTION,
      TrackingEvent.Sources.CAAS,
      { source: 'id_banner' },
    );

    DeeplinkEvent.openWebview(
      `${NavigationUtils.Routes.WALLET}?organization=${card.organizationCode}&source=${NavigationUtils.Sources.HOME}`,
    );
  }

  return (
    <div
      className={`${style.container} ${_className(
        config[CaasStorageKeys.STORAGE].seeCards,
        style.showing,
      )}`}
    >
      <div className={style['cards-list']} data-testid="card-list">
        {defaultCards.map(card => (
          <LuckyCardListItem
            card={card}
            className={style.item}
            onClick={() => onCardItemClick(card)}
            lendingButtonEnabled={lendingButtonEnabled}
          />
        ))}
        <div
          className={`${style['hidden-cards']} ${_className(
            config[CaasStorageKeys.STORAGE].seeCards,
            style.showing,
          )}  ${_className(!hiddenCards.length, style.hidden)}`}
        >
          {hiddenCards.map(card => (
            <LuckyCardListItem
              card={card}
              className={style.item}
              onClick={() => onCardItemClick(card)}
            />
          ))}
        </div>
      </div>

      {renderIf(
        cards.length > DEFAULT_SHOWING_CARD_NUMBER,
        <div class={style['cards-control']}>
          <Button
            onClick={() => {
              TrackingEvent.trigger(
                TrackingEvent.Events.DISCOVER_TAP_ACTION,
                TrackingEvent.Sources.CAAS,
                {
                  source: !config[CaasStorageKeys.STORAGE].seeCards
                    ? 'view_all'
                    : 'view_less',
                },
              );
              updateStorage(
                'seeCards',
                !config[CaasStorageKeys.STORAGE].seeCards,
              );
            }}
          >
            {config[CaasStorageKeys.STORAGE].seeCards
              ? `${t('See less cards')} (-${
                  cards.length - DEFAULT_SHOWING_CARD_NUMBER
                })`
              : `${t('See all cards')} (+${
                  cards.length - DEFAULT_SHOWING_CARD_NUMBER
                })`}
          </Button>
        </div>,
      )}
    </div>
  );
}
